import { ReactComponent as Icon } from "./filter-off-line.svg";

const FilterOffLineIcon = () => <Icon />;

export default FilterOffLineIcon;
